<template>
    <div class="main main-padding tabs-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--产品类型下拉框-->
            <div class="pro-download">
                <span>产品类型:</span>
                <Select v-model="params.proKey" style="width:200px" @on-change="onChange">
                    <Option v-for="item in proList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <!--时间选择器-->
            <div class="time-select-picker">
                <div class="time-select">
                    <Row :gutter="10">
                        <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
                    </Row>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--头部tab及搜索框-->
            <div class="card-header-area">
                <!--tab切换数据-->
                <div class="tab-data">
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="tabsName" v-if="params.proKey=='1'">
                        <TabPane label="教师大屏使用次数详情" name="teaUseDetails"></TabPane>
                        <TabPane label="教师使用大屏详情" name="teaUseCodeDetails"></TabPane>
                    </Tabs>
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="tabsName" v-if="params.proKey=='2'">
                        <TabPane label="教师移动授课使用次数详情" name="teaUseDetails"></TabPane>
                        <TabPane label="教师使用移动授课助手详情" name="teaUseCodeDetails"></TabPane>
                    </Tabs>
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="tabsName" v-if="params.proKey=='3'">
                        <TabPane label="教师备课助手使用次数详情" name="teaUseDetails"></TabPane>
                        <TabPane label="教师使用备课助手详情" name="teaUseCodeDetails"></TabPane>
                    </Tabs>
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="tabsName" v-if="params.proKey=='4'">
                        <TabPane label="教师智能PC使用次数详情" name="teaUseDetails"></TabPane>
                        <TabPane label="教师使用智能PC详情" name="teaUseCodeDetails"></TabPane>
                    </Tabs>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="params.keyWord"
                        placeholder="支持场景编码、行为编码、创建时间关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--教师使用产品详情-->
                <div class="table-wrapper-data" v-if="tabIndex==1">
                    <Table :columns="teaColumn" :data="teaUseList"></Table>
                </div>
                <!--教师使用产品次数详情-->
                <div class="table-wrapper-data" v-if="tabIndex==-1">
                    <Table :columns="codeColumn" :data="teaUseCodeList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="params.total"
                        :current="params.page"
                        :page-size="params.limit"
                        @on-change="handleCurrentChange"
                        v-show="params.total && params.pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>
<script>
    import {getUserCountDataList, getCodingDataList} from "../../../../service/api.js";
    import dateSelect from "../../../../components/dateSelect.vue";

    export default {
        name: "pro-use-details",
        data () {
            return {
                params: {
                    schoolId: this.$route.query.schoolId,
                    schoolName: this.$route.query.schoolName,
                    startTime: this.$route.query.selfStartDate,//上一个页面选择的开始时间
                    endTime: this.$route.query.selfEndDate,//上一个页面选择的结束时间
                    selfStartDate: this.$route.query.selfStartDate,
                    selfEndDate: this.$route.query.selfEndDate,
                    parentalStartDate: this.$route.query.parentalStartDate,//主页面选择的结束时间
                    parentalEndDate: this.$route.query.parentalEndDate,//主页面选择的结束时间
                    userId: this.$route.query.userId,
                    proKey: this.$route.query.proKey,
                    routerResource: this.$route.query.routerResource,
                    keyWord: "",
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0,
                },
                tabIndex: 1,//默认显示教师使用各产品详情表格
                teaColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "用户姓名",
                        key: "fullName",
                        align: "center"
                    },
                    {
                        title: "场景编码",
                        key: "funcName",
                        align: "center"
                    },
                    {
                        title: "行为编码",
                        key: "clsName",
                        align: "center"
                    },
                    {
                        title: "动态数据",
                        key: "dynamic_data",
                        align: "center"
                    },
                    {
                        title: "创建时间",
                        key: "create_time",
                        align: "center"
                    }
                ],
                codeColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "用户姓名",
                        key: "fullName",
                        align: "center"
                    },
                    {
                        title: "场景编码",
                        key: "funcName",
                        align: "center"
                    },
                    {
                        title: "动态数据",
                        key: "dynamic_data",
                        align: "center"
                    },
                    {
                        title: "次数",
                        key: "count",
                        align: "center"
                    }
                ],
                proList: [
                    {
                        value: "1",
                        label: '大屏'
                    },
                    {
                        value: "2",
                        label: '移动授课助手'
                    },
                    {
                        value: "3",
                        label: '备课助手'
                    },
                    {
                        value: "4",
                        label: '智能PC'
                    }
                ],
                teaUseList: [],//教师使用各产品详情
                teaUseCodeList: [],//教师使用各产品的场景编码详情
                tabsName: "teaUseDetails"
            };
        },
        components: {
            dateSelect
        },
        methods: {
            /**
             * 返回上一页
             * @param routerResource：-1，返回主页；1，返回上一页表格数据
             */
            gotoBack () {
                if (this.params.routerResource == -1) {
                    this.$router.push({
                        name: "boardMain",
                        query: {
                            schoolId: this.params.schoolId,
                            schoolName: this.params.schoolName,
                            startDate: this.params.selfStartDate,
                            endDate: this.params.selfEndDate,
                        }
                    });
                } else {
                    this.$router.push({
                        name: "teaUseProduct",
                        query: {
                            schoolId: this.params.schoolId,
                            schoolName: this.params.schoolName,
                            parentalStartDate: this.params.selfStartDate,//二级页面选择的开始时间
                            parentalEndDate: this.params.selfEndDate,//二级页面选择的结束时间
                            curSeleMainStartDate: this.params.parentalStartDate,//一级页面选择的开始时间
                            curSeleMainEndDate: this.params.parentalEndDate,//一级页面选择的结束时间
                            type: 1,
                            productKey: this.params.proKey,
                        }
                    });
                }

            },
            /**
             *点击切换产品类型下拉框
             */
            onChange (val) {
                this.params.proKey = val;
                this.params.total = 0;
                this.params.page = 1;
                //初始化tab页
                this.tabsName = "teaUseDetails";
                this.changeDataDetailsIndex(this.tabsName);
            },
            /**
             *搜索关键字
             */
            handleSearch () {
                this.params.total = 0;
                this.params.page = 1;
                if (this.tabIndex == -1) {
                    //显示教师使用各产品详情表格，并获取相关数据
                    this.queryTeaUseProSceneCodeDetails();
                } else if (this.tabIndex == 1) {
                    //显示教师使用各产品的次数详情，并获取数据
                    this.queryTeaUseProDetails();
                }
            },
            /**
             *翻页
             */
            handleCurrentChange (val) {
                this.params.page = val;
                if (this.tabIndex == -1) {
                    //显示教师使用各产品详情表格，并获取相关数据
                    this.queryTeaUseProSceneCodeDetails();
                } else if (this.tabIndex == 1) {
                    //显示教师使用各产品的次数详情，并获取数据
                    this.queryTeaUseProDetails();
                }
            },
            /**
             * 点击tab切换数据信息
             */
            changeDataDetailsIndex (tabsName) {
                //初始化参数
                this.params.keyWord = "";
                this.params.page = 1;
                this.params.total = 0;
                this.tabsName = tabsName;
                if (tabsName == 'teaUseDetails') {
                    //显示教师使用各产品详情表格，并获取相关数据
                    this.tabIndex = -1;
                    this.queryTeaUseProSceneCodeDetails();
                } else if (tabsName == 'teaUseCodeDetails') {
                    //显示教师使用各产品的次数详情，并获取数据
                    this.tabIndex = 1;
                    this.queryTeaUseProDetails();
                }
            },
            /**
             *获取教师使用各产品详情数据
             */
            async queryTeaUseProDetails () {
                let _this = this;
                let params = {
                    schoolId: _this.params.schoolId,
                    startTime: _this.params.startTime,
                    endTime: _this.params.endTime,
                    userId: _this.params.userId,
                    proKey: _this.params.proKey,
                    keyWord: _this.params.keyWord,
                    page: _this.params.page,
                    limit: _this.params.limit
                };
                await getUserCountDataList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.teaUseList = data.rows;
                            _this.params.total = data.total_rows;
                            _this.params.pageCount = Math.ceil(data.total_rows / _this.params.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取教师使用各产品的场景编码详情
             */
            async queryTeaUseProSceneCodeDetails () {
                let _this = this;
                let params = {
                    schoolId: _this.params.schoolId,
                    startTime: _this.params.startTime,
                    endTime: _this.params.endTime,
                    userId: _this.params.userId,
                    proKey: _this.params.proKey,
                    keyWord: _this.params.keyWord,
                    page: _this.params.page,
                    limit: _this.params.limit
                };
                await getCodingDataList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.teaUseCodeList = data.rows;
                            _this.params.total = data.total_rows;
                            _this.params.pageCount = Math.ceil(data.total_rows / _this.params.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 更新开始时间结束时间
             */
            updateDateTime (startDate, endDate) {
                this.params.page = 1;
                this.params.startTime = startDate;
                this.params.endTime = endDate;
                this.queryTeaUseProSceneCodeDetails();
            }
        },
        mounted () {
            this.$nextTick(() => {
                //修改公共属性学校名称
                this.$store.commit("SET_TOPHEADERNAME", this.params.schoolName);
                let tabsName=this.params.routerResource==-1?'teaUseDetails':'teaUseCodeDetails';
                this.tabIndex=this.params.routerResource;
                this.changeDataDetailsIndex(tabsName);
                //记住页面选择的开始和结束时间
                this.$refs.dateSelect.setDate(this.params.startTime, this.params.endTime);
            })
        }
    };
</script>
<style lang="scss" scoped>
    @import "../../../../style/home";
    @import "../../../../style/dataDetails";
</style>
<style lang="scss">
    .tabs-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
            top: 0;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-table-tip {
            overflow-x: hidden;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }
        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
